module.exports = __webpack_public_path__ + "img/SmallCrocodileNew.68f9d8f3.png";